export default {
  methods: {
    goBack(id, defaultRoute = null) {
      const lastRoute = sessionStorage.getItem(`goback.${id}`);
      if (lastRoute === null) {
        if (defaultRoute !== null) {
          this.$router.push(defaultRoute);
        } else {
          this.$router.back();
        }
      } else {
        sessionStorage.removeItem(`goback.${id}`);
        this.$router.push(lastRoute);
      }
    },
    saveCurrentAndGo(id, route) {
      sessionStorage.setItem(`goback.${id}`, this.$router.currentRoute.fullPath);
      this.$router.push(route);
    },
  },
};
